import React, { useEffect, useState } from 'react';
import { message } from 'antd';
import { useLocation } from 'react-router-dom';
import unit from './unit';
import Cookies from 'react-cookies';
import closeIcon from './assets/close.png';
import './App.css';

const Code = () => {
  const [messageApi, contextHolder] = message.useMessage();

  // 绑定手机号弹窗状态
  const [isBindModalVisible, setBindModalVisible] = useState(false);
  // 手机号
  const [phoneNumber, setPhoneNumber] = useState('');
  // 验证码
  const [verifyCode, setVerifyCode] = useState('');
  // 倒计时
  const [countdown, setCountdown] = useState(0);

  const [unionid, setUnionid] = useState('');
  const [nickname, setNickname] = useState('');
  const [avatar, setAvatar] = useState('');

  // 绑定冲突提示弹窗信息（code=12016 时展示）
  const [conflictInfo, setConflictInfo] = useState(null);
  // 账户合并确认弹窗信息（code=12017 时展示）
  const [mergeInfo, setMergeInfo] = useState(null);

  useEffect(() => {
    // 获取 URL 中的 code 参数
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    if (code) {
      // 如果获取到 code，打印出来
      console.log('获取到的 code:', code);
      // 向后端接口发送请求
      unit.httpGet('/user/weixin/webLoginByCode', {"code": code}, (data) => {
        // 登录成功，处理逻辑
        console.log('登录成功:', data);
        messageApi.open({type: "success", content: "登录成功"});
        
        // 浏览器本地保存用户信息
        window.localStorage.setItem("user_id", data.user_id);
        window.localStorage.setItem("nickname", data.nickname);
        window.localStorage.setItem("avatar", data.avatar);
        setUnionid(data.unionid);
        setNickname(data.nickname);
        setAvatar(data.avatar);
        // 存储cookie
        Cookies.save('web_qtstr', data.web_qtstr, {path:"/", maxAge: 86400*7, domain:'cangweizaixian.com'});
        
        // 检查是否需要绑定手机号
        if (data.need_bind_mobile === true) {
          setBindModalVisible(true);
        } else {
          // 不需要绑定手机号，直接跳转回首页
          window.history.go(-1);
        }
      }, (error) => {
        messageApi.open({type: "Warning",content: "绑定失败"});
        window.localStorage.removeItem("user_id");
        window.localStorage.removeItem("nickname");
        window.localStorage.removeItem("avatar");
        Cookies.remove('web_qtstr', {path:"/", domain:'cangweizaixian.com'});
        window.history.go(-1);
      });
    }
  }, []);

  // 发送验证码
  const sendVerifyCode = () => {
    if (!phoneNumber) {
      messageApi.open({type: "Warning",content: "请输入手机号"});
      return;
    }
    
    // 验证手机号格式
    const phoneRegex = /^1[3-9]\d{9}$/;
    if (!phoneRegex.test(phoneNumber)) {
      messageApi.open({type: "Warning",content: "请输入正确的手机号"});
      return;
    }
    
    // 发送验证码请求
    let formData = new FormData();
    formData.append('mobile', phoneNumber);
    unit.httpPost('/sso/sendVerifyCode', formData, {}, (data) => {
      console.log('验证码发送成功:', data);
      let _countdown = 60;
      // 倒计时
      const timer = setInterval(() => {
          console.info(9999,'55555');
          if (_countdown <= 0) {
            clearInterval(timer);
            return 0;
          }
          _countdown -= 1;
        console.info(_countdown,'55555');
        setCountdown(_countdown);
      }, 1000);
    }, (error) => {
      messageApi.open({type: "Warning",content: "验证码发送失败"});
    });
  };

  // 提交绑定请求
  const submitBind = () => {
    let formData = new FormData();
    formData.append('mobile', phoneNumber);
    formData.append('unionid', unionid);
    formData.append('nickname', nickname);
    formData.append('avatar', avatar);
    formData.append('confirm', 0);
    unit.httpPost('/user/weixin/bindAccount',formData, {
      code: verifyCode
    }, (data) => {
      messageApi.open({type: "success",content: "手机号绑定成功"});
      setBindModalVisible(false);
      setMergeInfo(null);
      setConflictInfo(null);
      window.localStorage.setItem("user_id", data.user_id);
      Cookies.save('web_qtstr', data.web_qtstr, {path:"/", maxAge: 86400*7, domain:'cangweizaixian.com'});
      // 绑定成功后跳转回首页
      //window.history.go(-1);
    }, (error, data) => {
      console.info(data);
      // code=12016：该微信已绑定到其他账号，需要展示冲突提示弹窗
      if (error === 12016 && data && data.alert) {
        setConflictInfo(data.alert);
        return;
      }
      // code=12017：该微信绑定账户已被注册，需要展示账户合并确认弹窗
      if (error === 12017 && data && data.alert) {
        setMergeInfo(data.alert);
        return;
      }
      messageApi.open({type: "Warning",content: "手机号绑定失败"});
      //window.localStorage.removeItem("user_id");
      //window.localStorage.removeItem("nickname");
      //window.localStorage.removeItem("avatar");
      //Cookies.remove('web_qtstr', {path:"/", domain:'cangweizaixian.com'});
      //window.history.go(-1);
    });
  };

  // 确认绑定手机号
  const handleBindPhone = () => {
    if (!phoneNumber) {
      messageApi.open({type: "Warning",content: "请输入手机号"});
      return;
    }
    
    if (!verifyCode) {
      messageApi.open({type: "Warning",content: "请输入验证码"});
      return;
    }

    submitBind();
  };

  // 确认合并账户：只把 mergeInfo.param 内的字段提交给接口，与首次绑定参数互不干扰
  const handleMergeConfirm = () => {
    if (!mergeInfo || !mergeInfo.param) return;
    const p = mergeInfo.param;
    let formData = new FormData();
    formData.append('mobile', phoneNumber);
    formData.append('unionid', unionid);
    if (p.confirm != null) formData.append('confirm', p.confirm);
    if (p.is_change != null) formData.append('is_change', p.is_change);
    if (p.retain_user_id) formData.append('retain_user_id', p.retain_user_id);
    if (p.retain_user_name) formData.append('retain_user_name', p.retain_user_name);
    if (p.retain_user_type != null) formData.append('retain_user_type', p.retain_user_type);
    if (p.cancel_user_id) formData.append('cancel_user_id', p.cancel_user_id);
    if (p.cancel_user_name) formData.append('cancel_user_name', p.cancel_user_name);
    if (p.cancel_user_type != null) formData.append('cancel_user_type', p.cancel_user_type);
    if (p.sign) formData.append('sign', p.sign);
    if (p.time != null) formData.append('time', p.time);
    unit.httpPost('/user/weixin/bindAccount', formData, {}, (data) => {
      messageApi.open({type: "success", content: "账户合并成功"});
      setMergeInfo(null);
      setConflictInfo(null);
      setBindModalVisible(false);
      window.localStorage.setItem("user_id", data.user_id);
      if (data.web_qtstr) {
        Cookies.save('web_qtstr', data.web_qtstr, {path:"/", maxAge: 86400*7, domain:'cangweizaixian.com'});
      }
      window.history.go(-1);
    }, (error, data) => {
      console.info(data);
      messageApi.open({type: "Warning", content: "账户合并失败"});
    });
  };

  // 关闭冲突提示弹窗
  const handleConflictClose = () => {
    setConflictInfo(null);
  };

  // 关闭账户合并确认弹窗
  const handleMergeClose = () => {
    setMergeInfo(null);
  };

  const handleClose = () => {
  setBindModalVisible(false);
  window.localStorage.removeItem("user_id");
  window.localStorage.removeItem("nickname");
  window.localStorage.removeItem("avatar");
  Cookies.remove('web_qtstr', {path:"/", domain:'cangweizaixian.com'});
  window.history.go(-1);
};

  return (
    <div className="bind-phone-modal" style={isBindModalVisible ? {display: 'flex'} : {display: 'none'}}>
      <div className="modal-content">
        {/* 标题 */}
        <div className="modal-header">
          <h3>绑定手机号，解锁更多<span style={{ color:"#F23031" }}>会员功能</span></h3>
          <p className="c-xieyi">就差最后一步，加油!别放弃!</p>
          <img 
            src={closeIcon} 
            alt="关闭" 
            className="close-btn" 
            onClick={handleClose} 
          />
        </div>
        
        {/* 表单 */}
        <div className="modal-body">
          {contextHolder}
          <div className="form-group">
            <input
              type="tel"
              placeholder="请输入手机号"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              maxLength={11}
              className="form-control"
            />
          </div>
          
          <div className="form-group">
            <input
              type="text"
              placeholder="请输入验证码"
              value={verifyCode}
              onChange={(e) => setVerifyCode(e.target.value)}
              maxLength={6}
              className="form-control"
            />
            <button
              className="get-code-btn"
              disabled={countdown > 0}
              onClick={sendVerifyCode}
            >
              {countdown > 0 ? `${countdown}s后重试` : '获取验证码'}
            </button>
          </div>
          
          {/* 确认按钮 */}
          <button 
            className="bind-btn" 
            onClick={handleBindPhone}
          >
            确定
          </button>
          
          {/* 协议声明 */}
          <p className="code-xieyi">
            注册登录即代表您已阅读并同意
            <a href="https://api.huijinzhitou.com/news/detail?from=back&res_type=html5&id=11388746">《用户服务协议》</a>
            <a href="https://api.huijinzhitou.com/news/detail?from=back&res_type=html5&id=11380937">《隐私政策》</a>
          </p>
        </div>
      </div>

      {/* 绑定冲突提示弹窗（code=12016） */}
      {conflictInfo && (
        <div className="conflict-modal">
          <div className="conflict-content">
            <div className="conflict-header">
              <h3>{conflictInfo.title || '提示'}</h3>
              <img
                src={closeIcon}
                alt="关闭"
                className="close-btn"
                onClick={handleConflictClose}
              />
            </div>
            <div className="conflict-body">
              {conflictInfo.text && (
                <p className="conflict-text">{conflictInfo.text}</p>
              )}
              {conflictInfo.tips && (
                <p className="conflict-tips">{conflictInfo.tips}</p>
              )}
              {Array.isArray(conflictInfo.list) && conflictInfo.list.length > 0 && (
                <ul className="conflict-list">
                  {conflictInfo.list.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              )}
              <button className="conflict-btn" onClick={handleConflictClose}>
                {conflictInfo.button_text || '我知道了'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 账户合并确认弹窗（code=12017） */}
      {mergeInfo && (
        <div className="conflict-modal">
          <div className="merge-content">
            <div className="conflict-header">
              <h3>{mergeInfo.title || '账户合并'}</h3>
              <img
                src={closeIcon}
                alt="关闭"
                className="close-btn"
                onClick={handleMergeClose}
              />
            </div>
            <div className="conflict-body">
              {mergeInfo.text && (
                <p className="conflict-text">{mergeInfo.text}</p>
              )}
              <div className="merge-cards">
                {mergeInfo.retain && (
                  <div className="merge-card merge-card-retain">
                    <div className="merge-tag merge-tag-retain">{mergeInfo.retain.tag || '保留账户'}</div>
                    <img className="merge-avatar" src={mergeInfo.retain.avatar} alt="头像" />
                    <div className="merge-nickname">{mergeInfo.retain.nickname}</div>
                    {mergeInfo.retain.vip && (
                      <div className="merge-vip">{mergeInfo.retain.vip}</div>
                    )}
                  </div>
                )}
                {mergeInfo.cancel && (
                  <div className="merge-card merge-card-cancel">
                    <div className="merge-tag merge-tag-cancel">{mergeInfo.cancel.tag || '注销账户'}</div>
                    <img className="merge-avatar" src={mergeInfo.cancel.avatar} alt="头像" />
                    <div className="merge-nickname">{mergeInfo.cancel.nickname}</div>
                    {mergeInfo.cancel.vip && (
                      <div className="merge-vip">{mergeInfo.cancel.vip}</div>
                    )}
                  </div>
                )}
              </div>
              {mergeInfo.tips && (
                <p className="merge-tips">{mergeInfo.tips}</p>
              )}
              <div className="merge-actions">
                <button className="merge-btn merge-btn-cancel" onClick={handleMergeClose}>
                  取消
                </button>
                <button className="merge-btn merge-btn-confirm" onClick={handleMergeConfirm}>
                  {mergeInfo.button_text || '确认合并'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Code;